import Vue from "vue";
import VueMeta from "vue-meta";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import setup from "./utils/setup";

setup(Vue);
Vue.use(VueMeta);

const fahrzeugId = new URLSearchParams(window.location.search).get("fahrzeug");
let fahrzeugRedirectDone = false;

// Bis zur Umstellung auf history mode wurden Links im hash mode Format
// (z.B. "#/?fahrzeugtyp=..." oder "#/fahrzeug/123") verteilt/indexiert.
// Diese Links weiterhin unterstützen, indem der Hash in einen echten
// Pfad + Query umgewandelt wird.
let hashRedirectPath = null;
if (window.location.hash.startsWith("#/")) {
  hashRedirectPath = window.location.hash
    .slice(1)
    .replace(/^\/fahrzeug\//, "/");
}
let hashRedirectDone = false;

router.beforeEach((to, from, next) => {
  if (fahrzeugId && !fahrzeugRedirectDone && to.name !== "fahrzeug") {
    fahrzeugRedirectDone = true;
    next({ name: "fahrzeug", params: { id: fahrzeugId }, replace: true });
  } else if (hashRedirectPath && !hashRedirectDone) {
    hashRedirectDone = true;
    const resolved = router.resolve(hashRedirectPath).route;
    next({ path: resolved.path, query: resolved.query, replace: true });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
